
import React from "react";
import { MapPin } from "lucide-react";

interface LeadLocationProps {
  location: string;
}

export const LeadLocation = ({ location }: LeadLocationProps) => {
  if (!location) return null;
  
  return (
    <div className="flex items-center gap-1 max-w-[180px]">
      <MapPin className="h-3 w-3 flex-shrink-0" />
      <span className="truncate">{location}</span>
    </div>
  );
};
